import { useEffect, useState } from "react";
import { RangePickerProps } from "antd/lib/date-picker";
import dayjs, { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";

import { ListStoreConstructor } from "stores/ListStoreConstructor";
import { DefaultRangeDateInput } from "../DefaultDateInput";
import { Col } from "antd";
import { dateISOFormat } from "utils";

export interface DateSearchInputProps extends Omit<RangePickerProps, "prefix"> {
  store: ListStoreConstructor<any>;
}

export const DateSearchInput = observer(({ className, store, ...props }: DateSearchInputProps) => {
  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null] | null>(() => {
    const startDate = store.queryParams["startDate"];
    const endDate = store.queryParams["endDate"];

    if (startDate && endDate) {
      return [dayjs(startDate), dayjs(endDate)];
    }

    return null;
  });

  const handleDateChange: RangePickerProps["onChange"] = (dates, dateStrings) => {
    setDateRange(dates);

    if (dates && dates[0] && dates[1]) {
      store.onChangeDataFlow({
        paginationData: {
          currentPage: 1,
          pageSize: store.paginationData.pageSize,
        },
        filters: {
          ...store.filters,
          startDate: dateISOFormat(dates[0], false),
          endDate: dateISOFormat(dates[1], false),
        },
        sorters: store.sorters,
      });
    } else {
      store.onChangeDataFlow({
        paginationData: {
          currentPage: 1,
          pageSize: store.paginationData.pageSize,
        },
        filters: {
          ...store.filters,
          startDate: undefined,
          endDate: undefined,
        },
        sorters: store.sorters,
      });
    }
  };

  useEffect(() => {
    if (!store.filters?.startDate && !store.filters?.endDate && dateRange) {
      setDateRange(null);
    }
  }, [store.filters, dateRange]);

  return (
    <Col className={className}>
      <DefaultRangeDateInput {...props} value={dateRange} onChange={handleDateChange} allowClear />
    </Col>
  );
});
